// The English strings, one file per section of the UI.
// A new section gets its file and one import line here.
import app from "./en/app.json" with { type: "json" };
import common from "./en/common.json" with { type: "json" };
import setup from "./en/setup.json" with { type: "json" };
import signIn from "./en/signIn.json" with { type: "json" };
import security from "./en/security.json" with { type: "json" };
import projects from "./en/projects.json" with { type: "json" };
import catalogue from "./en/catalogue.json" with { type: "json" };
import live from "./en/live.json" with { type: "json" };
import pwa from "./en/pwa.json" with { type: "json" };
import help from "./en/help.json" with { type: "json" };
import nav from "./en/nav.json" with { type: "json" };
import table from "./en/table.json" with { type: "json" };
import danger from "./en/danger.json" with { type: "json" };
import connection from "./en/connection.json" with { type: "json" };
import overview from "./en/overview.json" with { type: "json" };
import errors from "./en/errors.json" with { type: "json" };
import sshKeys from "./en/sshKeys.json" with { type: "json" };
import servers from "./en/servers.json" with { type: "json" };
import serverCreate from "./en/serverCreate.json" with { type: "json" };
import publicIps from "./en/publicIps.json" with { type: "json" };
import networks from "./en/networks.json" with { type: "json" };
import firewalls from "./en/firewalls.json" with { type: "json" };
import serverConsole from "./en/console.json" with { type: "json" };
import images from "./en/images.json" with { type: "json" };
import dashboard from "./en/dashboard.json" with { type: "json" };
import volumes from "./en/volumes.json" with { type: "json" };
import floatingIps from "./en/floatingIps.json" with { type: "json" };
import placementGroups from "./en/placementGroups.json" with { type: "json" };
import loadBalancers from "./en/loadBalancers.json" with { type: "json" };
import certificates from "./en/certificates.json" with { type: "json" };
import users from "./en/users.json" with { type: "json" };
import access from "./en/access.json" with { type: "json" };
import invite from "./en/invite.json" with { type: "json" };
import autopilot from "./en/autopilot.json" with { type: "json" };
import terminal from "./en/terminal.json" with { type: "json" };
import rdp from "./en/rdp.json" with { type: "json" };
import sessions from "./en/sessions.json" with { type: "json" };
import apiAccess from "./en/apiAccess.json" with { type: "json" };
import oauth from "./en/oauth.json" with { type: "json" };
import costs from "./en/costs.json" with { type: "json" };
import budgets from "./en/budgets.json" with { type: "json" };
import notifications from "./en/notifications.json" with { type: "json" };
import alerts from "./en/alerts.json" with { type: "json" };
import monitoring from "./en/monitoring.json" with { type: "json" };
import assistant from "./en/assistant.json" with { type: "json" };
import packages from "./en/packages.json" with { type: "json" };

export const en = {
  app,
  common,
  setup,
  signIn,
  security,
  projects,
  catalogue,
  live,
  pwa,
  help,
  nav,
  table,
  danger,
  connection,
  overview,
  errors,
  sshKeys,
  servers,
  serverCreate,
  publicIps,
  networks,
  firewalls,
  console: serverConsole,
  images,
  dashboard,
  volumes,
  floatingIps,
  placementGroups,
  loadBalancers,
  certificates,
  users,
  access,
  invite,
  autopilot,
  terminal,
  rdp,
  sessions,
  apiAccess,
  oauth,
  costs,
  budgets,
  notifications,
  alerts,
  monitoring,
  assistant,
  packages,
};
